import React from 'react';
import PropTypes from 'prop-types';

import Button from './Button';
import EllipsisToolTip from './EllipsisToolTip';

import styles from '../../styles/views/components/TopBar.module.scss';

function TopBar({
  elementsAtLeft,
  elementsAtMiddle,
  elementsAtRight,
  extraStyles,
  subTitles,
  redirectTitle,
  onRedirect,
  isRedirectVisible,
}) {
  const titleTooltip = subTitles.join(' ');

  return (
    <header className={styles.container} style={extraStyles}>
      <div className={[styles.topbarElements, styles.left].join(' ')}>
        {elementsAtLeft}
        {isRedirectVisible && (
          <Button
            name={redirectTitle}
            variant="link"
            color="red"
            icon="arrowLeft"
            value={redirectTitle}
            onClick={onRedirect}
          />
        )}
        <EllipsisToolTip tooltipText={titleTooltip}>
          <div className={`${styles.title} ${isRedirectVisible ? styles.titleWithRedirect : ''}`}>
            {subTitles.length > 0 && subTitles.map((title, i) => {
              if (title?.isLabel) {
                return (
                  <React.Fragment key={title.name}>
                    <span
                      className={styles.label}
                      style={{ color: title.colors.text, background: title.colors.background }}
                    >
                      {title.name}
                    </span>
                  </React.Fragment>
                );
              }
              return (
                <React.Fragment key={title}>
                  {i === 0 ? null : <span className={styles.icon} />}
                  {title}
                </React.Fragment>
              );
            })}
          </div>
        </EllipsisToolTip>
      </div>
      <div className={[styles.topbarElements, styles.middle].join(' ')}>
        {elementsAtMiddle}
      </div>
      <div className={[styles.topbarElements, styles.right].join(' ')}>
        {elementsAtRight}
      </div>
    </header>
  );
}

TopBar.defaultProps = {
  elementsAtLeft: [],
  elementsAtMiddle: [],
  elementsAtRight: [],
  subTitles: [],
  extraStyles: null,
  redirectTitle: '',
  onRedirect: () => {},
  isRedirectVisible: false,
};

TopBar.propTypes = {
  elementsAtLeft: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
  ]),
  elementsAtMiddle: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
  ]),
  elementsAtRight: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
  ]),
  extraStyles: PropTypes.shape({}),
  subTitles: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
  ]),
  redirectTitle: PropTypes.string,
  onRedirect: PropTypes.func,
  isRedirectVisible: PropTypes.bool,
};

export default TopBar;
